//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import moment from "moment";
export default {
  name: 'SafetyProductionList',
  mixins: [JeecgListMixin, GetSiteIdMixin],
  components: {},
  data: function data() {
    return {
      pagePath: '/ai/event/push',
      pageTitle: '危险区域',

      /* 数据源 */
      dataSource: [],
      // 表头
      columns: [],
      times: [],

      /* 分页参数 */
      ipagination: {
        current: 1,
        pageSize: 8,
        pageSizeOptions: ['8', '24', '32', '40'],
        showTotal: function showTotal(total, range) {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      isorter: {
        column: 'create_time',
        order: 'desc'
      },
      modalName: '图片',
      // 是否显示图片
      showImgModal: false,
      ImgModaUrl: '',
      queryParam: {
        eventType: '1'
      },
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点',
        align: 'center',
        sorter: true
      }
    };
  },
  created: function created() {
    this.limitSelectDate = {
      min: moment().startOf('day').subtract(1, 'week'),
      max: moment().endOf('day')
    };
    this.queryParam.sdate = this.limitSelectDate.min.format('YYYY-MM-DD HH:mm:ss');
    this.queryParam.edate = this.limitSelectDate.max.format('YYYY-MM-DD HH:mm:ss');
    this.times = [moment(this.queryParam.sdate, 'YYYY-MM-DD HH:mm:ss'), moment(this.queryParam.edate, 'YYYY-MM-DD HH:mm:ss')];
  },
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();
      console.log(value);
      this.queryParam.scopeId = ids[1];
      this.queryParam.scope = ids[0];
      this.queryParam.category = this.category;
      console.log(ids[1], ids[0]);

      if (ids[0] == 1) {
        // 根据站点id
        this.queryParam.siteId = ids[1];
        this.spliceColumn(this.siteColumn);
      } else {
        // 根据区域id
        this.queryParam.siteId = undefined;
        this.spliceColumn(this.siteColumn, 1);
      }

      this.delayLoadData();
    }
  },
  computed: {},
  methods: {
    searchReset: function searchReset() {
      this.queryParam = {
        eventType: '1'
      };
      this.dates = {};
      this.searchResetImpl();
      this.loadData(1);
    },

    /* 重载而不清空页面类型*/
    modalFormOk: function modalFormOk() {
      // 新增/修改 成功时，重载列表
      this.queryParam = {
        eventType: '1'
      };
      this.$refs.modalForm.showTab = false;
      this.loadData();
    },
    onDate: function onDate(value, dateArray) {
      this.queryParam.sdate = dateArray[0];
      this.queryParam.edate = dateArray[1];
    },
    handleTableChange: function handleTableChange(pagination, filters) {
      this.ipagination.current = pagination;
      this.ipagination.pageSize = filters;
      this.loadData();
    },
    // 现场图片关闭
    setModal1Visible: function setModal1Visible() {
      this.showImgModal = false;
    },
    detail: function detail(params) {
      this.ImgModaUrl = params;
      this.showImgModal = true;
    }
  }
};